// ============================================================
// 矩阵雨：Hero 背景 Canvas（支持 off / normal / overdrive 模式）
// ============================================================

const CHARS =
  "01JKDYAI极客导演视频图像音乐$#%&<>[]{}*+=/\\|_~^;:,.?!";

const MODE_STYLE = {
  off: { opacity: 0, speed: 0 },
  normal: { opacity: 0.5, speed: 1 },
  overdrive: { opacity: 0.95, speed: 2.6 },
};

const OVERDRIVE_MS = 8000; // 超频模式自动回落时长

export default function initMatrix() {
  const canvas = document.getElementById("matrix-canvas");
  if (!canvas) return null;

  const ctx = canvas.getContext("2d");
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  let cols = 0;
  let drops = [];
  let fontSize = 16;
  let raf = 0;
  let last = 0;
  let speed = MODE_STYLE.normal.speed;
  let overdriveTimer = null;

  const resize = () => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = canvas.clientWidth;
    const h = canvas.clientHeight;
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    fontSize = w < 640 ? 14 : 16;
    cols = Math.ceil(w / fontSize);
    drops = Array.from({ length: cols }, () => Math.floor(Math.random() * -40));
  };

  const draw = (now) => {
    raf = requestAnimationFrame(draw);
    if (speed === 0 || reduced) return;
    if (now - last < 33) return; // 约 30fps 限流，控制开销
    last = now;

    ctx.fillStyle = "rgba(4, 7, 13, 0.09)";
    ctx.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    ctx.font = `${fontSize}px Consolas, monospace`;

    for (let i = 0; i < cols; i++) {
      const ch = CHARS[Math.floor(Math.random() * CHARS.length)];
      const bright = Math.random() > 0.975;
      ctx.fillStyle = bright ? "#e8f4ff" : Math.random() > 0.5 ? "#00ff9c" : "#00b371";
      ctx.fillText(ch, i * fontSize, drops[i] * fontSize);

      if (drops[i] * fontSize > canvas.clientHeight && Math.random() > 0.975) {
        drops[i] = Math.floor(Math.random() * -20);
      }
      drops[i] += 1 * speed;
    }
  };

  const setMode = (mode) => {
    const style = MODE_STYLE[mode] || MODE_STYLE.normal;
    canvas.style.opacity = String(style.opacity);
    speed = style.speed;

    if (mode === "overdrive") {
      clearTimeout(overdriveTimer);
      overdriveTimer = setTimeout(() => setMode("normal"), OVERDRIVE_MS);
    }
  };

  resize();
  window.addEventListener("resize", resize);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      cancelAnimationFrame(raf);
      raf = 0;
    } else if (!raf) {
      raf = requestAnimationFrame(draw);
    }
  });

  raf = requestAnimationFrame(draw);
  setMode("normal");

  return { setMode };
}
